import { BaseCarousel } from './BaseCarousel';

export function getDefaultMixCardsCarouselProps() {
  return {
    slickSettings: BaseCarousel.defaultSlickSettings,
    containerStyles: {},
  };
}
